"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.SzDropDown = void 0;

var react_1 = __importDefault(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var __1 = require("../../");

require("./SzDropDown.scss");

exports.SzDropDown = function (_a) {
  var value = _a.value,
      className = _a.className,
      children = _a.children,
      id = _a.id,
      onSelect = _a.onSelect,
      show = _a.show,
      alignRight = _a.alignRight;
  var CustomToggle = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children,
        onClick = _a.onClick;
    return react_1.default.createElement(__1.SzButton, {
      variant: "tertiary",
      className: "dropdown-button-toggle",
      icon: !value ? 'navigation-menu-vertical' : '',
      onClick: onClick
    }, children);
  });
  var CustomMenu = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children,
        className = _a.className;
    return react_1.default.createElement("div", {
      ref: ref,
      className: className
    }, react_1.default.createElement(__1.SzList, null, children));
  });
  var dropDownClasses = classnames_1.default('sz-dropdown font-family-bold', className);
  var toggleClasses = classnames_1.default('d-flex dropdown-basic border-0 w-100 text-secondary');
  return react_1.default.createElement(react_bootstrap_1.Dropdown, {
    className: dropDownClasses,
    alignRight: alignRight,
    onSelect: onSelect,
    show: show
  }, react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, {
    as: CustomToggle,
    bsPrefix: toggleClasses,
    id: id
  }, value && react_1.default.createElement("div", null, react_1.default.createElement("span", null, value), react_1.default.createElement(__1.SzIcon, {
    icon: "arrow-down-1",
    variant: "bold",
    className: "normal ml-2 align-self-center text-right"
  }))), react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, {
    className: "px-2",
    as: CustomMenu
  }, children));
};

exports.Item = function (_a) {
  var children = _a.children,
      onClick = _a.onClick,
      icon = _a.icon;
  return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, {
    onClick: onClick,
    className: "p-0 font-weight-bold align-items-center w-auto",
    as: __1.SzList.Item
  }, react_1.default.createElement(__1.SzButton, {
    icon: icon,
    variant: "tertiary",
    className: "w-100 my-2 justify-content-start"
  }, children));
};

exports.SzDropDown.Item = exports.Item;
exports.default = exports.SzDropDown;